<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template>
<div>
  <v-row>
      <v-col
        cols="12"
        class="text-center subheading pt-0 mb-3 mt-3"
        style="font-weight: 500;"
      ><span v-if='countrySelected === false'>Highest </span>Cases % of Population</v-col>
    </v-row>
    <v-row style="height: 100%;" class="pa-3 pt-0">
      <v-col cols="12" :md="countrySelected === false? 4: 12" v-for="item in items" :key="item.country" class="pa-0 ma-0 mb-4">
        <div class="ma-2 mb-0 mt-0" v-bind:style="{ 'min-height': $vuetify.breakpoint.lg? '152px !important': 'inherit', 'background-color': 'rgb(23 42 73)' }">
          <div class="pa-3">
            <div class="subheading font-weight-medium"><v-icon class="mr-3" dark>notes</v-icon>{{item.country}}</div>
            <div class="caption mt-3" style="font-weight: 300;">had <span class="body-2 pink--text text--lighten-2" style='border-bottom: 1px dotted; font-weight: 500;'>{{item.percentage + '%'}}</span> of the population confirmed positive</div>
          </div>
        </div>
      </v-col>
    </v-row>
</div>
</template>

<script>
export default {
  name: "HighestCasesPopulation",
  data: () => ({
    items: [],
    countrySelected: false,
  }),
  methods: {
    loadCases(data, countryDisplay) {
      //clear data
      this.items = [];

      //check no data
      if (data.length === 0) {
        return;
      }

      if(countryDisplay && countryDisplay !== "") {
        this.countrySelected = true
      }
      else {
        this.countrySelected = false
      }

      //calculate the weekly % change in confirmed for the last 4 weeks and add them up
      //the countries with the highest sum are the ones to be watched
      var topcountries = [];
      for (var i = 0; i < data.length; i++) {
        
        //calculate the latest confirmed of population
        var latestconfirmed = data[i].cases[data[i].cases.length - 1].cumulative_cases
        var totalpop = data[i].population.population*1

        var perc = (latestconfirmed/totalpop) * 100
        perc = parseFloat(perc.toFixed(2))

        topcountries.push({
          country: data[i].Country_WHO,
          percentage: perc
        });
      }

      //sort by count desc
      topcountries = topcountries.sort(function (a, b) {
        a = a.percentage;
        b = b.percentage;
        return a > b ? -1 : a < b ? 1 : 0;
      });

      //only take the top ones
      topcountries = topcountries.slice(0, 6);

      this.items = topcountries;

    },
    getNumberDisplay(number) {
      return number.toLocaleString("en").replace(/\,/g, " ");
    },
    getCasesForDay(date, cases) {
      var cumulative = 0
      
      var match = cases.find(c => c.date === date)
      if(match) {
        cumulative = match.cumulative_cases
      }

      return cumulative
    },
  },
};
</script>